import moment from 'moment-timezone';

export const TimezoneAbbr = (timeZone) => {
  const zone = timeZone ? moment.tz.zone(timeZone) : moment.tz.zone(moment.tz.guess());
  return zone.abbr(new Date().getTime());
}

export const RegenerateDateWithTZ = (date, timedata, zone) => {
  const time = timedata.substring(0, 5);
  const offset = moment(date, 'YYYY-MM-DDTHH:mm:ss.ss').tz(zone).format('Z');
  const eventdate = moment(date).format('YYYY-MM-DD');
  return `${eventdate}T${time}:00.0000${offset}`;
}

export const ExtractTimeFromDatetime = (datetime) => {
  if (!datetime) return '00:00';
  return datetime.includes('T') ? datetime.split('T')[1].substring(0, 5) : '00:00';
}
